import { Col, Row } from '@design-system/components/grid/grid';
import { Desc } from '../../../promotions/view/components/FormTypography';
import { TextInput } from '../../../promotions/view/components/TextInput';
import * as s from './form.css';
import { Typography } from '@design-system/components/typography/typography';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { extrasVM } from '../Extras.page';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileDownload } from '@fortawesome/pro-regular-svg-icons';
import { BannerImage } from '../components/BannerImage';
import { convertFileSize } from '@client/helpers/file-utils';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';

export const PDFForm = () => {
  const p = extrasVM.useValue().pdfVM;
  return (
    <div>
      <Col data-testid="ContentPDFForm" gap="xl" className={s.wrapper}>
        <Row>
          <Typography variant="body" size="large" fontWeight="medium">
            PDF Document
          </Typography>
          <SuperTooltip templateId="extras-pdf" />
        </Row>
        <Row>
          <Col>
            <Desc>Upload PDF document. Max size: 30MB</Desc>
          </Col>
        </Row>
        <Row>
          <div className={s.pdfPill}>
            <FontAwesomeIcon className={s.icon} icon={faFileDownload} />
            <span className={s.fileName}>{p.content.fileName}</span>
            <span className={s.fileSize}>
              {convertFileSize(p.content.fileSize || 0)}
            </span>
            <div className={s.actions}>
              <a href={p.content.url} target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faDownload} color="#000" />
              </a>
              <span
                className={s.replaceButton}
                onClick={() => p.dispatch('PrepareReupload')}
              >
                Replace
              </span>
            </div>
          </div>
        </Row>
        <TextInput
          label="Title"
          description="This title will be shown to your users"
          {...p.register('title')}
          required
        />

        <BannerImage
          imageUrl={p.values.coverURL}
          onChange={(url) => p.onChange('coverURL', url)}
        />

        <Row className={s.divider}>
          <Typography variant="body" size="large" fontWeight="medium">
            Downloadable
          </Typography>
          <Tooltip
            arrow
            title="Toggle this on to allow users to download content for offline use"
            variant="dark"
            tooltipProps={{
              maxWidth: 195,
            }}
          >
            <div>
              <Toggle
                value={p.values.downloadable}
                onChange={() =>
                  p.onChange('downloadable', !p.values.downloadable)
                }
              />
            </div>
          </Tooltip>
        </Row>
      </Col>
    </div>
  );
};

// export type InputProps<T, TK extends keyof T> = {
//   name: TK;
//   label: string;
//   error?: string;
//   onChange: (name: TK, value: T[TK]) => void;
//   required?: boolean;
//   value: T[TK];
// };

// const SmartTextInput = <T, TK extends keyof T>(p: InputProps<T, TK>) => (
//   <>
//     <TextInput
//       label={p.label}
//       required={p.required}
//       value={p.value + ''}
//       onChange={(e) => p.onChange(p.name, e.target.value as any)}
//       error={p.error}
//     />
//   </>
// );
